import {
  GET_CONFIGURATIONS,
  GET_CONFIGURATION,
  UPDATE_CONFIGURATION,
  CREATE_CONFIGURATION,
  DELETE_CONFIGURATION,
  TOGGLE_CONFIGURATION_STATUS,
  GET_CONFIGURATIONS_REQUEST_PENDING,
  GET_CONFIGURATIONS_REQUEST_SUCCESS,
  GET_CONFIGURATIONS_REQUEST_ERROR,
  CHANGE_CONFIGURATIONS_REQUEST_PENDING,
  CHANGE_CONFIGURATIONS_REQUEST_SUCCESS,
  CHANGE_CONFIGURATIONS_REQUEST_ERROR,
} from '../types/configurations'

const initialState = {
  items: [],
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  item: {},
  filters: {
    platform: '',
    searchKey: '',
    isActive: '',
  },
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const configurations = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIGURATIONS:
      return { 
        ...state, 
        items: action.payload.items,
        pagination: action.payload.pagination,
        filters: action.payload.filters || state.filters,
      }
    
    case GET_CONFIGURATION:
      return { ...state, item: action.payload }
    
    case UPDATE_CONFIGURATION:
      const updateItemIndex = state.items.findIndex((item) => item.id === action.payload.id)
      const updatedItems = [...state.items]
      if (updateItemIndex !== -1) {
        updatedItems[updateItemIndex] = { ...action.payload }
      }
      return { ...state, items: updatedItems }
    
    case CREATE_CONFIGURATION:
      return { ...state, items: [action.payload, ...state.items] }
    
    case DELETE_CONFIGURATION:
      return { ...state, items: state.items.filter((item) => item.id !== action.payload) }
    
    case TOGGLE_CONFIGURATION_STATUS:
      const toggleItemIndex = state.items.findIndex((item) => item.id === action.payload.id)
      const toggledItems = [...state.items]
      if (toggleItemIndex !== -1) {
        toggledItems[toggleItemIndex] = { ...action.payload }
      }
      return { ...state, items: toggledItems }
    
    case GET_CONFIGURATIONS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    
    case GET_CONFIGURATIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    
    case GET_CONFIGURATIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    
    case CHANGE_CONFIGURATIONS_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }
    
    case CHANGE_CONFIGURATIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }
    
    case CHANGE_CONFIGURATIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }
    
    default:
      return state
  }
}

export default configurations
